import { FileText, X } from 'lucide-react';
import { formatFileSize } from '../../../../services/apiClient';

/**
 * Modal listing files already registered in the File Manager (built-in,
 * user-uploaded, and ETL-generated) so one can be picked as the conformance
 * reference (Soll-Prozess) model, instead of uploading a new file.
 *
 * Rendered as an absolutely-positioned overlay confined to the nearest
 * `position: relative` ancestor (the tile's BaseTile container), so it
 * stays aligned with that container rather than the outer draggable/
 * resizable grid tile.
 */
const ReferenceFilePickerModal = ({ files = [], onSelect, onClose }) => {
  return (
    <div
      className="absolute inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center overflow-y-auto p-4 pt-10"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[75%] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Select Reference File</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors text-gray-500"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto overscroll-contain p-4">
          {files.length === 0 ? (
            <p className="text-sm text-gray-500 text-center py-6">
              No files available in the File Manager.
            </p>
          ) : (
            <div className="space-y-2">
              {files.map((file) => (
                <button
                  key={file.file_type}
                  type="button"
                  onClick={() => onSelect(file)}
                  className="w-full flex items-center gap-3 p-3 border border-gray-200
                    rounded-lg text-left hover:border-gray-300 hover:bg-gray-50 transition-colors"
                >
                  <FileText className="w-5 h-5 text-gray-400 shrink-0" />
                  <div className="min-w-0 flex-1">
                    <p className="font-medium text-gray-900 truncate">
                      {file.display_name || file.file_type}
                    </p>
                    <div className="flex items-center gap-2 mt-0.5 text-sm text-gray-500">
                      <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-xs">
                        {file.is_user_upload ? 'Uploaded' : 'Built-in'}
                      </span>
                      {typeof file.file_size === 'number' && <span>{formatFileSize(file.file_size)}</span>}
                    </div>
                  </div>
                  {!file.exists && (
                    <span className="text-xs text-red-500 shrink-0">missing</span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferenceFilePickerModal;
